module.exports = __webpack_public_path__ + "static/favicon-8c898b2fddc651a021e40885355ce65a.ico";